import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/calendar/events')({
    component: () => <Outlet />,
    staticData: {
        crumb: {
            label: 'Events',
        }
    }
})
